import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ComponentWillMountSymbol } from 'feature-components'
import { Chat } from './chat'

export const page: ContainerModuleLoader = (bind) => {
	bind(ComponentWillMountSymbol).to(Chat)
}
